var map = {
	"./Agua.jpg": 376,
	"./Armario.jpg": 377,
	"./Bano.jpg": 227,
	"./Calor.jpg": 1532,
	"./Climatizacion.jpg": 378,
	"./Coche color.jpg": 379,
	"./Cocina.jpg": 380,
	"./Ducha.jpg": 381,
	"./Escaleras.jpg": 1533,
	"./Pared.jpg": 1534,
	"./Puerta de paso.jpg": 382,
	"./Suelo.jpg": 228,
	"./cristalero.jpg": 229,
	"./electricista.jpg": 383,
	"./electrodomesticos.jpg": 230,
	"./jardinero.jpg": 384,
	"./manitas.jpg": 385,
	"./piscina.jpg": 231,
	"./toldos-y-persianas.jpg": 232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;